module.exports = __webpack_public_path__ + "static/media/bio-1@2x.799878bd.jpg";